// Command-side lifecycle notifications for the authenticated canonical store.
// They are local UI hints; only canonical REST/socket resources are authoritative.
const listeners = new Set();

export function subscribeOptimisticMessaging(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function publishOptimisticMessaging(event) {
  listeners.forEach(listener => listener(event));
}
